/**
 * Drive 快捷方式列表项
 */

export var SHORT_CUT_KIND = 'drive#shortcut';
export function isShortcut(node) {
  return node.kind === SHORT_CUT_KIND;
}
//# sourceMappingURL=shortcut.js.map